<script setup lang="ts">
/* Stores */
import { useCityStore } from '@/store/city/city'

const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  archive: {
    type: Boolean,
    required: true,
  },
})

const {
  cityInfo: { padeg },
} = useCityStore()

const saleImageAlt = `Акция «${props.title}» в ${padeg?.pred}`

const saleImageTitle = `Акция «${props.title}» от ресторана Farfor в ${padeg?.pred}`

const isSaleImageCrashed = ref(false)

const saleImage =
  !isSaleImageCrashed || props?.image ? props?.image : './no-image-sale.webp'
</script>

<template>
  <nuxt-img
    :src="saleImage"
    :alt="saleImageAlt"
    :title="saleImageTitle"
    class="sale-content__image"
    :class="{ 'image--opacity': archive }"
    loading="lazy"
    format="webp"
    fit="contain"
    quality="80"
    @error="isSaleImageCrashed = true"
  />
</template>
